import { validateProps } from '../utils';
import { isValidBase } from './BaseEntity';
export let InitiatorType = /*#__PURE__*/function (InitiatorType) {
  InitiatorType["UNKNOWN_INITIATOR_TYPE"] = "UNKNOWN_INITIATOR_TYPE";
  InitiatorType["SERVICE"] = "SERVICE";
  InitiatorType["PROVIDER"] = "PROVIDER";
  InitiatorType["CONTACT"] = "CONTACT";
  return InitiatorType;
}({});
export const isValidGuidelines = properties => {
  const ans = isValidBase(properties) && validateProps(properties, ['initiatorType', 'initiatorId']);
  return ans;
};
//# sourceMappingURL=Guidelines.js.map